import { TAvailByDayResp } from '@/domain/Availability.domain';
import instance from '../Axios';
import { ApiUrls } from '@/service/constants/urls';
import { replaceLightframe } from '@/service/utils/replaceLightframe';

export const getAvailabilityByDay = (
    partnerId: string,
    trip_id: string,
    date: string
): Promise<TAvailByDayResp> => {
    return instance
        .post<TAvailByDayResp>(
            ApiUrls.availability.day.root,
            {
                trip_id,
                date,
            },
            {
                params: {
                    partnerId: replaceLightframe(partnerId),
                },
            }
        )
        .catch(() => {
            console.log('[ERROR] Fetch availability by day ', trip_id, date);

            return { data: [] };
        })
        .then(({ data }) => data);
};
